import React from 'react';
import { useTranslation } from 'react-i18next';

const Button = ({
  children,
  isLoading,
  variant = '',
  className = '',
  disabled,
  ...props
}) => {
  const { t } = useTranslation();
  const baseStyles = 'py-3 px-4 h-[40px] rounded-[6px] font-medium transition-all duration-200 flex items-center justify-center';
  const variants = {
    primary: 'bg-[linear-gradient(160deg,#136BF0_0%,#0C49A6_100%)] hover:bg-[linear-gradient(-80deg,#136BF0_0%,#0C49A6_100%)] text-white',
    secondary: 'bg-[linear-gradient(160deg,#FF9900_0%,#FF6A01_100%)] hover:bg-[linear-gradient(-80deg,#FF9900_0%,#FF6A01_100%)] text-white',
    ternary:'bg-white text-primary'
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${
        disabled || isLoading ? 'opacity-70 cursor-not-allowed' : ''
      } ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin h-5 w-5 mr-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          {t('button.loading')}
        </>
      ) : (
        children
      )}
    </button>
  );
};

export default Button; 